import axios from 'axios';
import { getToken, logout } from './auth';
import BaseService from './baseService';

const api = axios.create();

export const setupInterceptors = navigate => {
    api.interceptors.request.use(
    async config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config;
    }, error => {
        Promise.reject(error)
    });

    api.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        BaseService.handleError(error);

        if (error.response &&
            error.response.status &&
            error.response.status === 401) {
            logout();
            navigate('/login');
        }

        return Promise.reject(error);
    });
} 

export default api;